export const navItems = [
  {
    category: "Overview",
    iClass: "bi bi-grid-fill",
    url: "/console",
  },
  {
    category: "Merchants",
    iClass: "bi bi-shop",
    url: "/console?q=merchants",
  },
  {
    category: "Settings",
    iClass: "bi bi-gear-fill",
    url: "/console?q=settings",
  },
];
